import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = ({ homeContent, heroVid }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoRef = useRef(null);
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);

   // Preload video using a link tag
   useEffect(() => {
    const linkElement = document.createElement('link');
    linkElement.rel = 'preload';
    linkElement.as = 'video';
    linkElement.href = heroVid;
    linkElement.type = 'video/mp4';
    document.head.appendChild(linkElement);

    return () => {
      document.head.removeChild(linkElement);
    };
  }, [heroVid]);

    // Implement lazy loading with Intersection Observer
    useEffect(() => {
        const options = {
          root: null,
          rootMargin: '100px', // Start loading video 100px before it comes into view
          threshold: 0.1
        };
    
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setShouldLoadVideo(true);
              observer.unobserve(entry.target);
            }
          });
        }, options);
    
        if (videoRef.current) {
          observer.observe(videoRef.current);
        }
    
        return () => {
          if (videoRef.current) {
            observer.unobserve(videoRef.current);
          }
        };
      }, []);

  // placeholder background color 
  const placeholderStyle = {
    backgroundColor: '#1a1a1a', 
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: isVideoLoaded ? 0 : 1,
    transition: 'opacity 0.5s ease-in-out',
  };

  return (
    <section className="showcase relative pt-6 bg-gray-900"> 
      <div className="container relative z-10"> 
        <div className="hor">
          <div className="ver">
            <div className="content">
              <div className="header">
                <h1 className="blueDark">{homeContent.showcaseHeader1}</h1>
                <br />
                <h1 className="red">{homeContent.showcaseHeader2}</h1>
              </div>
              <div className="txtContent">
                <article>
                  <h3>{homeContent.showcaseHeader3}</h3>
                  <p>{homeContent.showcaseParagraph}</p>
                </article>
              </div>
              <div className="btnHolder">
                <Link to="/about-us" className="btnPrimary">
                  read more
                </Link>
              </div>
            </div>
          </div>
          <div className="ver">
            <div className="imgWrapper">
              {/* Image component here */}

                {/* <ProgressiveImage
                  lowQualitySrc={homeContent.showcaseImg.lowQuality}
                  highQualitySrc={homeContent.showcaseImg.highQuality}
                  alt={homeContent.showcaseHeader3}
                /> */}
            </div>
          </div>
        </div>
      </div>

      {/* Placeholder background */}
      <div style={placeholderStyle} />

      {/* Video overlay */}
      <div className="video__overlay absolute inset-0 z-0" />

      {/* Optimized video loading */}
      <video
       ref={videoRef}
        autoPlay
        muted
        playsInline
        loop
        id="hero-bgVid"
        className="absolute inset-0 w-full h-full object-cover z-0"
        onLoadedData={() => setIsVideoLoaded(true)}
        poster={homeContent.posterImg?.lowQuality} 
      >
         {shouldLoadVideo && <source src={heroVid} type="video/mp4" />}
      </video>
    </section>
  );
};

export default HeroSection;